import moment from 'moment';
import localforage from 'localforage';
import { httpX } from '@/plugins/http';
import { clone } from '@/helpers/object';

export function upsertAttendance({
  state, commit, rootState, rootGetters,
}, data) {
  const filters = {
    professionalId: null,
  };

  if (state.filter.professionalId) {
    filters.professionalId = state.filter.professionalId;
  } else if (rootGetters.isProfessionalOnly) {
    filters.professionalId = rootState.auth.user.id;
  }

  commit('Attendance.UPSERT', { ...data, filters });
}

export async function loadAttendanceFilters({ state, rootGetters }, type = 'elective') {
  const params = {
    limit: 0,
    active: true,
    type,
  };

  if (rootGetters.isProfessionalOnly) {
    params.isProfessional = rootGetters.isProfessionalOnly;
  }

  httpX.get('/schedules', { params })
    .catch(() => ({ items: [] }))
    .then(({ data }) => {
      state.filter.schedules = data.items;
      if (type === 'surgery' && data.items.length > 0) {
        state.filter.scheduleIds = [data.items[0].id];
      } else if (!data.items.some(({ id }) => id === state.filter.scheduleIds[0])) {
        state.filter.scheduleIds = [];
      }
    });
}

export async function loadAttendanceCalendar({
  commit, state, rootState, rootGetters,
}) {
  commit('Attendance.SET_LOADING', true);

  const params = {
    date: moment(state.filter.date).format('YYYY-MM-DD'),
  };

  if (state.filter.scheduleIds && state.filter.scheduleIds.length > 0) {
    params.scheduleId = state.filter.scheduleIds.join(',');
  }

  if (state.filter.professionalId) {
    params.professionalId = state.filter.professionalId;
  } else if (rootGetters.isProfessionalOnly) {
    params.professionalId = rootState.auth.user.id;
  }

  if (state.filter.statuses && state.filter.statuses.length > 0) {
    params.status = state.filter.statuses.join(',');
  }

  httpX.get('/calendar/attendances', { params })
    .then(({ data }) => {
      commit('Attendance.SET_ITEMS', data.items);
    })
    .catch(() => {
      commit('Attendance.SET_ITEMS', []);
    })
    .then(() => {
      commit('Attendance.SET_LOADING', false);
    });
}

export async function loadAttendanceConfig({ state, commit }, openModal = true) {
  state.config.processing = true;

  if (!state.config.loaded) {
    const data = await localforage.getItem('attendanceConfig');
    if (data) {
      commit('Attendance.UPDATE_CONFIG', data);
    }
    state.config.loaded = true;
  }

  state.config.processing = false;

  if (state.config.form.placeId && state.config.form.roomName) {
    return state.config.form;
  }

  if (openModal) {
    state.config.show = true;
  }

  return null;
}

export async function saveAttendanceConfig({ state, commit }, data) {
  state.config.processing = true;

  await localforage.setItem('attendanceConfig', clone(data));
  commit('Attendance.UPDATE_CONFIG', data);

  state.config.processing = false;
}
